module.exports = __webpack_public_path__ + "static/media/school-bench.370384d5.svg";